import { render, staticRenderFns } from "./newCustom.vue?vue&type=template&id=4fe02745&scoped=true&"
import script from "./newCustom.vue?vue&type=script&lang=js&"
export * from "./newCustom.vue?vue&type=script&lang=js&"
import style0 from "./newCustom.vue?vue&type=style&index=0&id=4fe02745&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe02745",
  null
  
)

export default component.exports